import React from "react";
import PropTypes from "prop-types";
import { TimestampConverter } from "@utils/TimestampConverter";
import CustomersSvg from "@assets/svgs/CustomersSvg";
import InfoIcon from "@assets/svgs/InfoIcon";
import MessageInputSvg from "@assets/svgs/MessageInputSvg";
import AgentSvg from "@assets/svgs/AgentSvg";
import UserProfileSvg from "@assets/svgs/UserProfileSvg";

const getIcon = (type) => {
  switch (type) {
    case "new_message":
      return <MessageInputSvg width="18" height="18" />;
    case "customer_assigned":
    case "customer_unassigned":
      return <CustomersSvg width="18" height="18" />;
    case "system":
      return <AgentSvg width="18" height="18" />;
    case "mention":
      return <UserProfileSvg width="18" height="18" />;
    default:
      return <InfoIcon width="18" height="18" />;
  }
};

const NotificationItem = ({ notification, onClick }) => {
  const { type, title, body, createdAt, read, data, customer } = notification;
  const safeTitle = title || "Notification";
  const safeBody = body || "";
  const profilePic =
    type === "new_message"
      ? data?.customer_profile_pic || customer?.profile_pic
      : null;

  return (
    <li 
      className={`notification-item ${!read ? "unread" : ""}`}
      onClick={() => onClick(notification)}
    >
      <div className={`notification-icon-wrapper ${type}`}>
        {profilePic ? (
          <img
            src={profilePic}
            alt=""
            className="notification-avatar"
          />
        ) : (
          getIcon(type)
        )}
      </div>
      <div className="notification-content">
        <span className="notification-title">{safeTitle}</span>
        <p className="notification-body">{safeBody}</p>
        <span className="notification-time">{TimestampConverter(createdAt)}</span>
      </div>
      {!read && <div className="notification-unread-dot" />}
    </li>
  );
};

NotificationItem.propTypes = {
  notification: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string,
    body: PropTypes.string,
    createdAt: PropTypes.string,
    read: PropTypes.bool,
    data: PropTypes.shape({ customer_profile_pic: PropTypes.string }),
    customer: PropTypes.shape({ profile_pic: PropTypes.string }),
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NotificationItem;
